export default {}

export const CHECK_AUTH = 'auth/user'

export const FETCH_PROFILE = 'profile/fetch'
export const FORGOT_PASSWORD = 'profile/forgotpassword'
export const RESET_PASSWORD = 'profile/resetpassword'
export const CHECH_PASSWORD_TOKEN = 'profile/checkPasswordToken'

export const REGISTER = 'register/addPerson'
export const REGISTER_RESET = 'register_reset'
export const CHECK_UID = 'register/existUid'
export const REGISTER_CONFIRM = 'register/confirm'

export const FETCH_USERS = 'users'
export const FETCH_USER = 'fetchUser'
export const USER_SAVE = 'userSave'
export const USER_REMOVE = 'userRemove'
export const USER_CREATE = 'userCreate'

export const USER_AND_ROLE_ADD = 'userAndRoleAdd'
export const USER_AND_ROLE_REMOVE = 'userAndRoleRemove'

export const FETCH_ROLES = 'groups'
export const FETCH_ROLE = 'fetchRole'
export const ROLE_EDIT_ADD_USER = 'addUserToRole'
export const ROLE_EDIT_REMOVE_USER = 'removeUserFromRole'
export const ROLE_CREATE = 'roleCreate'

export const FETCH_LAYERS = 'layers'
export const FETCH_LAYER = 'fetchLayer'
export const LAYER_ADD_RULE = 'layerAddRule'
export const LAYER_REMOVE_RULE = 'layerRemoveRule'
export const LAYER_SAVE_INFO = 'layerSaveInfo'
export const LAYER_SAVE_ATTRIBUTES = 'layerSaveAttributes'

export const FETCH_REFERENCES = 'references'
export const FETCH_REFERENCE = 'fetchReference'
export const UPDATE_REFERENCE = 'updateReference'
export const DELETE_REFERENCE = 'deleteReference'
export const ADD_REFERENCE = 'addReference'
export const REMOVE_REFERENCE = "removeReference"
export const CLEAR_CACHE = "clearCache"

export const FETCH_WORKSPACES = 'workspaces'
export const FETCH_WORKSPACE = 'fetchWorkspace'
export const WORKSPACE_ADD_RULE = 'workspaceAddRule'
export const WORKSPACE_REMOVE_RULE = 'workspaceRemoveRule'
export const WORKSPACE_CREATE = "workspaceCreate"
export const WORKSPACE_REMOVE = "workspaceRemove"
export const WORKSPACE_SAVE = "workspaceSave"

export const FETCH_LAYERGROUPS = 'layerGroups'
export const FETCH_LAYERGROUP = 'fetchLayerGroup'

export const FETCH_MAPS = 'maps'
export const FETCH_MAP = 'fetchMap'
export const MAP_REMOVE = 'mapRemove'
export const MAP_SAVE = 'mapSave'

export const FETCH_TOPICS = 'topics'
export const FETCH_TOPIC = 'fetchTopic'
export const TOPIC_REMOVE = 'topicRemove'
export const TOPIC_SAVE = 'topicSave'
export const TOPICS_LIST_SAVE = 'topicsListSave'

export const FETCH_EXTENTS = 'extents'

export const FETCH_GROUPUNITS = 'groupUnits'

export const FETCH_FONMAPS = 'fonmaps'
export const FETCH_FONMAP = 'fetchFonMaps'
export const FONMAP_REMOVE = 'fonMapRemove'
export const FONMAP_SAVE = 'fonMapSave'
export const FONMAPS_LIST_SAVE = 'fonMapsListSave'

export const FETCH_DATASTORES = 'datastores'
export const FETCH_DATASTORE = 'fetchDataStore'
export const DATASTORE_CREATE = 'dataStoreCreate'
export const DATASTORE_REMOVE = 'dataStoreRemove'
export const DATASTORE_SAVE = 'dataStoreSave'

export const MAP_LAYERS_SAVE = 'MAP_LAYERS_SAVE'
export const MAP_SAVE_INFO = 'MAP_SAVE_INFO'
export const MAP_CREATE = 'MAP_CREATE'
export const MAP_SAVE_LAYERS = 'MAP_SAVE_LAYERS'

export const FETCH_ERROR = 'fetchError'


// WEBPACK FOOTER //
// ./src/store/actions.type.js